import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import SupplyChain from './SupplyChain';

export default function Blog() {
  return (
    <>
        <Navbar />
        <SupplyChain />
        <Footer />
        <Copyright />
    </>
  )
}
